import gsap from 'gsap';

const runWhenVisible = (target, animation) => {
    if (!target) {
        return;
    }

    if (typeof window.IntersectionObserver === 'undefined') {
        animation();
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            animation();
            observer.unobserve(entry.target);
        });
    }, {
        threshold: 0.2,
    });

    observer.observe(target);
};

const faq = () => {
    const faqItems = document.querySelectorAll('.il-faq__item');
    const faqInner = document.querySelector('.il-faq__inner');
    if( faqItems.length === 0 ) return;
    if( !faqInner ) return;

    runWhenVisible(faqInner, () => {
        gsap.from(faqItems, {
            opacity: 0,
            x: 40,
            duration: 0.8,
            stagger: 0.15,
        });
    });
}

const grid = () => {
    const gridItems = document.querySelectorAll('.il-grid__item');
    const gridInner = document.querySelector('.il-grid__inner');
    if( gridItems.length === 0 ) return;
    if( !gridInner ) return;

    runWhenVisible(gridInner, () => {
        gsap.from(gridItems, {
            opacity: 0,
            y: 40,
            duration: 0.8,
            stagger: 0.15,
        });
    });
}

const numbers = () => {
    const items = document.querySelectorAll('.il-numbers__item');
    if( items.length === 0 ) return;

    items.forEach((item, index) => {
        const isEven = index % 2 === 0;

        runWhenVisible(item, () => {
            gsap.from(item, {
                x: isEven ? -100 : 100,
                opacity: 0,
                duration: 0.8,
                ease: "power2.out",
            });
        });
    });
}

const posts = () => {
    const postItems = document.querySelectorAll('.il-post');
    const postInner = document.querySelector('.il-posts-list');
    if( postItems.length === 0 ) return;
    if( !postInner ) return;

    runWhenVisible(postInner, () => {
        gsap.from(postItems, {
            opacity: 0,
            y: 40,
            duration: 0.8,
            stagger: 0.15,
        });
    });
}

numbers();
faq();
grid();
posts();